/**
 * Created by mac on 12/23/20
 */

const Merge3Generator = function (unit, options) {
    UnitComponent.call(this, unit);

    this.levels = unit.getData().merge3Generator.levels;

    this.level = options.level || 0;
    this.changedLevels = options.changedLevels || 0;

    if (this.levels && this.level >= this.levels) {
        setTimeout(this._gotoNextStage.bind(this), 0);
    }
};

Merge3Generator.prototype = Object.create(UnitComponent.prototype);
Merge3Generator.prototype.constructor = Merge3Generator;

Merge3Generator.prototype.save = function (data) {
    data.level = this.level;
    data.changedLevels = this.changedLevels;
};

Merge3Generator.prototype.destructor = function () {
    if (this.timeout) {
        clearTimeout(this.timeout);
        delete this.timeout;
    }
};

Merge3Generator.prototype._gotoNextStage = function () {
    const x = this.unit.x;
    const y = this.unit.y;
    const newUnit = new Unit({
        code: this.unit.code,
        stage: this.unit.stage + 1,
        level: 0,
        changedLevels: this.changedLevels
    });

    const view = this.view;
    this.unit.remove(true);
    newUnit.setPosition(x, y);
    Map2d.currentMap.onAddUnit(x, y, newUnit);
    Map2d.currentMap.onUnitAvailable(newUnit);
    Map2dLocation.currentLocation.counter.setTimeout(Map2d.mapEvent.bind(Map2dLocation.currentLocation, Map2d.SPAWN, { unit: newUnit }), 0);

    if (view) {
        view.updateStage(newUnit);
    }
};

Merge3Generator.prototype.gotoNextLevel = function () {
    if (this.levels && this.level + 1 >= this.levels) {
        this._gotoNextStage();
        return;
    }

    this.timeout = setTimeout(() => {
        delete this.timeout;

        if (this.levels) {
            this.level += 1;
        }
        this.changedLevels += 1;

        const mineable = this.unit.findComponent(Mineable);
        if (mineable) {
            mineable.reset();
        }

        this.unit.save();
    }, this.levels ? 600 : 0);
};

Merge3Generator.prototype.getGeneratorInfo = function () {
    if (this.levels) {
        return {
            progress: this.level + 1,
            total: this.levels
        };
    }
};